<div
  class="big-title-spotlight-section-wrap"
  [ngClass]="{
    tablet: globalUtilsService.isTablet(),
    mobile: globalUtilsService.isMobile()
  }"
>
  <h2>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12.041 20"
    >
      <path
        d="M396.223,59.345l-9.55,10.408h4.757l-2.962,9.592,10.246-11.02h-5.025Z"
        transform="translate(-386.673 -59.345)"
        fill="#2acc16"
      />
    </svg>
    MUDE PARA ENERGIA SOLAR
  </h2>

  <h1 translate="no">
    <div class="first-paragraph paragraph" translate="no">
      <div class="word">
        <div class="char">E</div>
        <div class="char">c</div>
        <div class="char">o</div>
        <div class="char">n</div>
        <div class="char">o</div>
        <div class="char">m</div>
        <div class="char">i</div>
        <div class="char">z</div>
        <div class="char">e</div>
      </div>
      <div class="word">
        <div class="char">a</div>
        <div class="char">t</div>
        <div class="char">é</div>
      </div>
      <div class="word">
        <div class="char">9</div>
        <div class="char">0</div>
        <div class="char">%</div>
      </div>
      <div class="word">
        <div class="char">n</div>
        <div class="char">a</div>
      </div>
      <div class="word">
        <div class="char">c</div>
        <div class="char">o</div>
        <div class="char">n</div>
        <div class="char">t</div>
        <div class="char">a</div>
      </div>
      <div class="word">
        <div class="char">d</div>
        <div class="char">e</div>
      </div>
      <div class="word">
        <div class="char">l</div>
        <div class="char">u</div>
        <div class="char">z</div>
      </div>
      <div class="word underline">_</div>
    </div>

    <div class="second-paragraph paragraph">
      <div class="word">
        <div class="char">R</div>
        <div class="char">á</div>
        <div class="char">p</div>
        <div class="char">i</div>
        <div class="char">d</div>
        <div class="char">o</div>
      </div>
      <div class="word">
        <div class="char">r</div>
        <div class="char">e</div>
        <div class="char">t</div>
        <div class="char">o</div>
        <div class="char">r</div>
        <div class="char">n</div>
        <div class="char">o</div>
      </div>
      <div class="word">
        <div class="char">s</div>
        <div class="char">o</div>
        <div class="char">b</div>
        <div class="char">r</div>
        <div class="char">e</div>
      </div>
      <div class="word">
        <div class="char">o</div>
      </div>
      <div class="word">
        <div class="char">i</div>
        <div class="char">n</div>
        <div class="char">v</div>
        <div class="char">e</div>
        <div class="char">s</div>
        <div class="char">t</div>
        <div class="char">i</div>
        <div class="char">m</div>
        <div class="char">e</div>
        <div class="char">n</div>
        <div class="char">t</div>
        <div class="char">o</div>
      </div>
      <div class="word underline">_</div>
    </div>

    <div class="third-paragraph paragraph">
      <div class="word">
        <div class="char">V</div>
        <div class="char">a</div>
        <div class="char">l</div>
        <div class="char">o</div>
        <div class="char">r</div>
        <div class="char">i</div>
        <div class="char">z</div>
        <div class="char">a</div>
        <div class="char">ç</div>
        <div class="char">ã</div>
        <div class="char">o</div>
      </div>
      <div class="word">
        <div class="char">i</div>
        <div class="char">m</div>
        <div class="char">e</div>
        <div class="char">d</div>
        <div class="char">i</div>
        <div class="char">a</div>
        <div class="char">t</div>
        <div class="char">a</div>
      </div>
      <div class="word">
        <div class="char">d</div>
        <div class="char">o</div>
      </div>
      <div class="word">
        <div class="char">s</div>
        <div class="char">e</div>
        <div class="char">u</div>
      </div>
      <div class="word">
        <div class="char">i</div>
        <div class="char">m</div>
        <div class="char">ó</div>
        <div class="char">v</div>
        <div class="char">e</div>
        <div class="char">l</div>
      </div>
      <div class="word underline">_</div>
    </div>

    <div class="fourth-paragraph paragraph">
      <div class="word">
        <div class="char">C</div>
        <div class="char">o</div>
        <div class="char">n</div>
        <div class="char">t</div>
        <div class="char">e</div>
      </div>
      <div class="word">
        <div class="char">c</div>
        <div class="char">o</div>
        <div class="char">m</div>
      </div>
      <div class="word">
        <div class="char">a</div>
      </div>
      <div class="word">
        <div class="char">P</div>
        <div class="char">a</div>
        <div class="char">r</div>
        <div class="char">a</div>
        <div class="char">í</div>
        <div class="char">s</div>
        <div class="char">o</div>
      </div>
      <div class="word">
        <div class="char">e</div>
      </div>
      <div class="word">
        <div class="char">e</div>
        <div class="char">c</div>
        <div class="char">o</div>
        <div class="char">n</div>
        <div class="char">o</div>
        <div class="char">m</div>
        <div class="char">i</div>
        <div class="char">z</div>
        <div class="char">e</div>
      </div>
      <div class="word underline">_</div>
    </div>


  </h1>

  <!-- <a class="fazer-simulacao-botao" href="https://simulador.paraisofotovoltaico.com.br/">
    <span>FAZER SIMULAÇÃO</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.5 12.121"
    >
      <g transform="translate(0.75 1.061)">
        <line
          x2="10"
          transform="translate(0 5)"
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <path
          d="M12,5l5,5-5,5"
          transform="translate(-7 -5)"
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </svg>
  </a> -->
</div>
